// extracted by mini-css-extract-plugin
export default {"printOnly":"Statement_printOnly__8g9oG","printingStatement":"Statement_printingStatement__UZ8b+"};